import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { TPropertyPage } from "properties/_models/PropertyMdl";
import { MEXICO_ATTRACTIONS, TAttraction } from "_common/attractions/attractions";

export const TARGET_TYPES: ATTRACTION_TYPE[] = [
    ATTRACTION_TYPE.AIRPORT,
    ATTRACTION_TYPE.TRAIN_STATION,
    ATTRACTION_TYPE.BUS_STATION,
    ATTRACTION_TYPE.HOSPITAL,
    ATTRACTION_TYPE.PUBLIC_BEACH,
    ATTRACTION_TYPE.PHARMACY,
    ATTRACTION_TYPE.GROCERY_STORE,
];

export function deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
}

export function getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371;
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

export function getNearestByType(property: TPropertyPage) {
    if (!property?.location.coordinates) return [];

    return TARGET_TYPES.map((type) => {
        const candidates = MEXICO_ATTRACTIONS.filter((a) => a.type === type)
            .map((a) => ({
                ...a,
                distance: getDistanceFromLatLonInKm(
                    property.location.coordinates[1],
                    property.location.coordinates[0],
                    a.coordinates.lat,
                    a.coordinates.lng,
                ),
            }))
            .sort((a, b) => a.distance - b.distance);

        return candidates.length ? { type, attraction: candidates[0] } : null;
    }).filter(Boolean) as { type: ATTRACTION_TYPE; attraction: TAttraction & { distance: number } }[];
}
